import VendedorService from '@/src/services/vendedor'

const vendedorMixin = {
    data(){
        return {
            vendedoresFields: [
                {
                  key: 'nome',
                  label: 'Nome',
                  class: 'size-col-20',
                  field: 'nome'
                },
                {
                  key: 'funcao',
                  label: 'Função',
                  class: 'size-col-20',
                  field: 'funcao'
                },
                {
                  key: 'codigoIdentificacao',
                  label: 'Código de Identificação',
                  class: 'size-col-20',
                  field: 'codigoIdentificacao'
                },
                { key: 'actions', label: '', class: 'size-col-10' },
              ]
        }
    },
    methods: {
        async registerVendedor(vendedor) {
            await VendedorService.create(vendedor)
        },
        loadVendedores() {
            return VendedorService.list().then(response => response.data)
        },
        async editVendedor(id, vendedor) {
            await VendedorService.update(id, vendedor)
        },
        async deleteVendedor(id) {
            await VendedorService.remove(id)
        }
    }
}

export default vendedorMixin;